import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const About = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="mb-12 text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Sobre a Associação
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conheça nossa história, missão e valores que nos guiam há mais de uma década.
          </p>
        </div>

        {/* Mission Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Nossa Missão</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            A Associação foi fundada com o objetivo de promover o bem-estar e a qualidade de vida de nossos associados, 
            através de uma gestão transparente, democrática e participativa.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Acreditamos que a transparência é fundamental para construir uma comunidade forte e unida. 
            Por isso, disponibilizamos todas as informações sobre nossa gestão de forma clara e acessível.
          </p>
        </div>

        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-3">Transparência</h3>
            <p className="text-gray-700">
              Todas as nossas ações e decisões são abertas e acessíveis a todos os associados.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-3">Compromisso</h3>
            <p className="text-gray-700">
              Trabalhamos incansavelmente para atender às necessidades de nossa comunidade.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-3">Participação</h3>
            <p className="text-gray-700">
              Incentivamos a participação ativa de todos os associados nas decisões importantes.
            </p>
          </div>
        </div>

        {/* History */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Nossa História</h2>
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              Fundada em 2014, a Associação nasceu do desejo de um grupo de moradores de criar 
              uma organização que representasse verdadeiramente os interesses da comunidade.
            </p>
            <p>
              Ao longo dos anos, crescemos e nos desenvolvemos, sempre mantendo nossos valores 
              fundamentais de transparência e compromisso com o bem-estar de todos.
            </p>
            <p>
              Hoje, contamos com mais de 500 associados e continuamos trabalhando para melhorar 
              a qualidade de vida em nossa comunidade através de projetos e iniciativas diversas.
            </p>
          </div>
        </div>

        {/* Contact Information */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Entre em Contato</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <div className="h-12 w-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Mail className="h-6 w-6 text-primary-600" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                <p className="text-gray-700">contato@associacao.com</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="h-12 w-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Phone className="h-6 w-6 text-primary-600" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Telefone</h3>
                <p className="text-gray-700">(11) 1234-5678</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="h-12 w-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <MapPin className="h-6 w-6 text-primary-600" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Endereço</h3>
                <p className="text-gray-700">
                  Rua Exemplo, 123<br />
                  São Paulo, SP - CEP 01234-567
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="h-12 w-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Clock className="h-6 w-6 text-primary-600" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Horário de Atendimento</h3>
                <p className="text-gray-700">
                  Segunda a Sexta: 9h às 18h<br />
                  Sábado: 9h às 12h
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;

